import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'


const SolicitarViaticosFormGroup = ({iError, iTouched, fIsSubmitting}) => {
  return(
    <Form.Group>
    <Form.Label text='VIATICOS' md={2} htmlFor='checkbox-solicitaViaticos' />
      <Col md={10}>
        <Field name='solicitaViaticos'>
          {({ field }) => (
            console.log(field),
            <Form.Checkbox
              {...field}
              isInvalid={iTouched && iError}
              checked={field.value}
              disabled={fIsSubmitting}
              id='checkbox-solicitaViaticos'
              label='Solicita Viáticos'
            />
          )}
        </Field>
      </Col>
      </Form.Group>
  )
}

export default React.memo(SolicitarViaticosFormGroup)
